import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useHarmonyContentStyles = makeStyles(() => ({
  introduction: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    lineHeight: '22px',
  },
  topSkills: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: spacing.sm,
  },
  skillButton: {
    border: 0,
    borderRadius: radius.sm,
    padding: `${spacing.sm}px ${spacing.md}px`,
    maxWidth: '100%',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.base,
    textTransform: 'uppercase',
    cursor: 'pointer',
    '&:hover': { filter: 'brightness(1.15)' },
    '&:focus-visible': { outline: `2px solid ${colors.primary}`, outlineOffset: 3 },
  },
  hint: {
    marginTop: `${spacing.sm}px !important`,
    fontStyle: 'italic',
    fontSize: fontSize.md,
  },
  score: {
    '& span': {
      color: `${colors.primaryDark} !important`,
    },
  },
}));
